<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                    <button class="btn btn-outline-info btn-sm ml-2" @click="showAutoModal = true">Gestione Automatici</button>
                </span>
                    ORDINA PRODOTTI        
            </div>
        </div>

        <AutomaticOrderModal 
            :show="showAutoModal" 
            :allProducts="prodotti" 
            @close="showAutoModal = false"
            @refresh-products="refreshProducts"
        />
            
        <div class="tab-cont">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text">Prodotto</th>
                        <th class="text">Quantità Da Ordinare (gr)</th>
                        <th class="text">Prezzo (€/100gr)</th>
                        <th class="text">Prezzo Totale</th>
                        <th class="text">Ordina</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(prodotto,i) in prodotti" :key="prodotto.code">
                            <td class="text pointer" ><input v-model="prodotto.descrizio" disabled /></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.quantitaordine" @input="()=> updateQuantita(prodotto.code,prodotto.quantita,null,null)"/></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.prezzo" @input="()=> updatePrezzo(prodotto.code,prodotto.prezzo)"/></td>
                            <td class="bg" >{{prodotto.prezzo /100 * prodotto.quantitaordine}}</td>
                            <td class="text" ><button   @click="()=>ordina(prodotto.code,prodotto.quantitaordine,i)">Ordina</button></td>
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
</template>






<script>
// @ is an alias to /src
import { store } from '../store/store.js'
import AutomaticOrderModal from '../components/AutomaticOrderModal.vue'

export default {
  name: 'TabellaMapP',
  components: {
    AutomaticOrderModal
  },
  data: function () {
            return {
                prodotti:[],
                quantita:'',
                showAutoModal: false,
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    displayProduct() {
        this.prodotti = [];
        this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  element.prezzo=element.prezzo?element.prezzo:0;
                  element.quantitamin=element.quantitamin?element.quantitamin:0; 
                  element.quantitaordine=element.quantitaordine?element.quantitaordine:0;
                  if(element.quantita <= element.quantitamin && element.stato != "ordinato"){
                      this.prodotti.push(element);
                  }
                  
            });
        })
    },
    refreshProducts() {
        this.prodotti = [];
        this.displayProduct();
    },
    ordina(code,quantitaordine,i) {
        this.axios.post(this.store.path+'ordina',{code:code,quantitaordine:quantitaordine,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                this.prodotti.splice(i,1)
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            /*response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });*/
        })
    },
    updatePrezzo(code,prezzo) {
        this.axios.post(this.store.path+'updatePrezzo',{code:code,prezzo:prezzo,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            /*response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });*/
        })
    },
  },
  
  beforeMount() {
      this.displayProduct();
  },
  
}
</script>



<style scoped>
.tab-cont {
    overflow-y: scroll;
    height: 93vh;
}
</style>